export default __webpack_public_path__ + "static/media/male_avatar.2ad07937.svg";